var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('to-cart-btn',{staticClass:"equipment-card__to-cart",attrs:{"product-id":_vm.actualItem.ID,"is-loading":_vm.isLoading,"in-cart":!!_vm.productInCart},on:{"click":function($event){$event.preventDefault();return _vm.addToCart($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }